import {
  ASSIGN_DRIVER_JOB_POOL,
  ASSIGN_DRIVER_JOB_POOL_FAILURE,
  ASSIGN_DRIVER_JOB_POOL_PROGRESS_FAILURE,
  ASSIGN_DRIVER_JOB_POOL_PROGRESS_SUCCESS,
  ASSIGN_DRIVER_JOB_POOL_SUCCESS,
  FETCH_JOB_POOL,
  FETCH_JOB_POOL_RELOAD_DATA,
  FETCH_JOB_POOL_FAILURE,
  FETCH_JOB_POOL_SUCCESS,
  FETCH_JOB_POOL_INTERSTATE,
  FETCH_JOB_POOL_INTERSTATE_RELOAD_DATA,
  FETCH_JOB_POOL_INTERSTATE_FAILURE,
  FETCH_JOB_POOL_INTERSTATE_SUCCESS,
  FETCH_CARGO_WISE_JOB_POOL,
  FETCH_CARGO_WISE_JOB_POOL_FAILURE,
  FETCH_CARGO_WISE_JOB_POOL_SUCCESS,
  FETCH_INTERSTATE_JOBS_ASSIGN,
  FETCH_INTERSTATE_JOBS_ASSIGN_FAILURE,
  FETCH_INTERSTATE_JOBS_ASSIGN_SUCCESS,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_FAILURE,
  ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_SUCCESS,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_FAILURE,
  ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_SUCCESS,
  ASSIGN_CONSOLIDATED_JOB,
  ASSIGN_CONSOLIDATED_JOB_SUCCESS,
  ASSIGN_CONSOLIDATED_JOB_FAILURE,
} from "@utils/actionTypes";

const INIT_STATE = {
  loadingJobPool: false,
  jobPoolData: null,
  assigningDriver: false,
  assigningDriverProgressSuccess: 0,
  assigningDriverProgressFailure: 0,
  assignedDriverData: null,
  interstateJobsAssignData: null,
  gettingInterstateJobsAssign: false,
  assigningInterstateJobsNotStartedInPool: false,
  assigningInterstateJobsStartedInPool: false,
  assigningConsolidatedJob: false,
};

const JobsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_JOB_POOL:
      return { ...state, loadingJobPool: true };
    case FETCH_JOB_POOL_RELOAD_DATA:
      return {
        ...state,
        jobPoolData: [],
        loadingJobPool: true
      };
    case FETCH_JOB_POOL_SUCCESS:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };
    case FETCH_JOB_POOL_FAILURE:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };
    case FETCH_JOB_POOL_INTERSTATE:
      return { ...state, loadingJobPool: true };
    case FETCH_JOB_POOL_INTERSTATE_RELOAD_DATA:
      return {
        ...state,
        jobPoolData: [],
        loadingJobPool: true };
    case FETCH_JOB_POOL_INTERSTATE_SUCCESS:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };
    case FETCH_JOB_POOL_INTERSTATE_FAILURE:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };
    case FETCH_CARGO_WISE_JOB_POOL:
      return { ...state, loadingJobPool: true };
    case FETCH_CARGO_WISE_JOB_POOL_SUCCESS:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };
    case FETCH_CARGO_WISE_JOB_POOL_FAILURE:
      return {
        ...state,
        jobPoolData: action.payload,
        loadingJobPool: false,
      };

    case ASSIGN_DRIVER_JOB_POOL:
      return { ...state, assigningDriver: true };
    case ASSIGN_DRIVER_JOB_POOL_SUCCESS:
      return {
        ...state,
        assignedDriverData: action.payload,
        assigningDriver: false,
        assigningDriverProgressSuccess: 0,
        assigningDriverProgressFailure: 0,
      };
    case ASSIGN_DRIVER_JOB_POOL_FAILURE:
      return {
        ...state,
        assignedDriverData: action.payload,
        assigningDriver: false,
        assigningDriverProgressSuccess: 0,
        assigningDriverProgressFailure: 0,
      };
    case ASSIGN_DRIVER_JOB_POOL_PROGRESS_SUCCESS:
      return {
        ...state,
        assigningDriverProgressSuccess:
          state.assigningDriverProgressSuccess + 1,
      };
    case ASSIGN_DRIVER_JOB_POOL_PROGRESS_FAILURE:
      return {
        ...state,
        assigningDriverProgressFailure:
          state.assigningDriverProgressFailure + 1,
      };

    case FETCH_INTERSTATE_JOBS_ASSIGN:
      return { ...state, gettingInterstateJobsAssign: true };
    case FETCH_INTERSTATE_JOBS_ASSIGN_SUCCESS:
      return {
        ...state,
        interstateJobsAssignData: action.payload,
        gettingInterstateJobsAssign: false,
      };
    case FETCH_INTERSTATE_JOBS_ASSIGN_FAILURE:
      return {
        ...state,
        interstateJobsAssignData: null,
        gettingInterstateJobsAssign: false,
      };

    case ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL:
      return { ...state, assigningInterstateJobsNotStartedInPool: true };
    case ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_SUCCESS:
      return {
        ...state,
        assigningInterstateJobsNotStartedInPool: false,
      };
    case ASSIGN_DRIVER_INTERSTATE_JOBS_NOT_STARTED_IN_POOL_FAILURE:
      return {
        ...state,
        assigningInterstateJobsNotStartedInPool: false,
      };

    case ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL:
      return { ...state, assigningInterstateJobsStartedInPool: true };
    case ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_SUCCESS:
      return {
        ...state,
        assigningInterstateJobsStartedInPool: false,
      };
    case ASSIGN_DRIVER_INTERSTATE_JOBS_STARTED_IN_POOL_FAILURE:
      return {
        ...state,
        assigningInterstateJobsStartedInPool: false,
      };

    case ASSIGN_CONSOLIDATED_JOB:
      return { ...state, assigningConsolidatedJob: true };
    case ASSIGN_CONSOLIDATED_JOB_SUCCESS:
      return { ...state, assigningConsolidatedJob: false };
    case ASSIGN_CONSOLIDATED_JOB_FAILURE:
      return { ...state, assigningConsolidatedJob: false };


    default:
      return state;
  }
};
export default JobsReducer;
